export var filterOptions = function (styleParams, requiredOptionsSubset) {
    return Object.keys(styleParams)
        .filter(function (key) { return requiredOptionsSubset.indexOf(key) >= 0; })
        .reduce(function (res, key) {
        res[key] = styleParams[key];
        return res;
    }, {});
};
export var hashToInt = function (str) {
    if (str === void 0) { str = ''; }
    var int = 0;
    for (var i = 0; i < str.length; i++) {
        int += str.charCodeAt(i);
    }
    return int;
};
//# sourceMappingURL=utils.js.map